import script from "./OsExecutadaViewPage.vue?vue&type=script&setup=true&lang=js"
export * from "./OsExecutadaViewPage.vue?vue&type=script&setup=true&lang=js"

import "./OsExecutadaViewPage.vue?vue&type=style&index=0&id=6a192142&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a192142"]])

export default __exports__